import React from "react";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import FaceAuth from "./FaceAuth";
import FaceAuth2 from "./FaceAuth2";

export default function MainAuth() {
  const { isLoggedIn, mode } = useAuthStore();

  if (!isLoggedIn) {
    return <></>;
  }
  return mode === 1 ? (
    <FaceAuth key="face-employee" />
  ) : (
    <FaceAuth2 key="face-intern" />
  );
}
